// eslint-disable-next-line import/prefer-default-export
export const IOS_APP_RELEASE_DATE = new Date('2025-04-17');
